var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"7653796cba8568be68d30eb4c1884d9917bf48ce"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["engine-frontend@apollograph"]={id:"7653796cba8568be68d30eb4c1884d9917bf48ce"};
      